export default __webpack_public_path__ + "static/media/person3.dfa21229.jpg";